import { createContext } from 'react'

const LangContext = createContext(
{
    lang    : 'en' ,
    setLang : () => null
});

export default LangContext ;